import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorIcon from '@mui/icons-material/Error';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from 'components/Dialog';
import PackageDateAddFlightDialog from 'components/PackageDateAddFlightDialog';
import ConfirmableLoadingButton from 'components/ConfirmableLoadingButton';
import FlightDetails from 'components/FlightDetails';
import AccordionController from 'components/AccordionController';
import PackageDateEditFlightPriceHistory from 'components/PackageEditTransportFlightPriceHistory';

import { useRemoveFlight } from 'lib';

import { PackageDateEditFlight_packageDate$key } from '__generated__/PackageDateEditFlight_packageDate.graphql';
import { PackageDateEditFlight_data$key } from '__generated__/PackageDateEditFlight_data.graphql';
import { PackageDateEditFlight_package$key } from '__generated__/PackageDateEditFlight_package.graphql';

type Props = {
  packageDate: PackageDateEditFlight_packageDate$key;
  data: PackageDateEditFlight_data$key;
  package: PackageDateEditFlight_package$key;
};

const PackageDateEditFlight: FC<Props> = props => {
  const packageDate = useFragment(
    graphql`
      fragment PackageDateEditFlight_packageDate on PackageDate {
        id

        flight {
          ...FlightDetails_flight
          ...PackageDateEditFlightPriceHistory_flight
        }

        ...PackageDateAddFlightDialog_packageDate
      }
    `,
    props.packageDate
  );

  const data = useFragment(
    graphql`
      fragment PackageDateEditFlight_data on Query {
        ...PackageDateAddFlightDialog_data
      }
    `,
    props.data
  );

  const pack = useFragment(
    graphql`
      fragment PackageDateEditFlight_package on Package {
        ...PackageDateAddFlightDialog_package
      }
    `,
    props.package
  );

  const { id, flight } = packageDate;
  const [removeFlight] = useRemoveFlight(id);

  return flight ? (
    <>
      <FlightDetails
        //warnings={<FlightWarnings flight={flight} />}
        flight={flight}>
        <ConfirmableLoadingButton
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon fontSize="small" />}
          confirmIcon={<ErrorIcon fontSize="small" />}
          onConfirm={removeFlight}>
          Trinti
        </ConfirmableLoadingButton>
      </FlightDetails>

      <AccordionController id="packageDateFlight">
        <PackageDateEditFlightPriceHistory flight={flight} />
      </AccordionController>
    </>
  ) : (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      variant="filled"
      action={
        <Dialog
          fullWidth
          maxWidth="md"
          activateButton={open => (
            <Button
              color="inherit"
              size="small"
              startIcon={<AddIcon />}
              onClick={open}>
              Pridėti
            </Button>
          )}>
          <PackageDateAddFlightDialog
            packageDate={packageDate}
            data={data}
            package={pack}
          />
        </Dialog>
      }>
      Šiai kelionės datai dar nėra skrydžio
    </Alert>
  );
};

export default PackageDateEditFlight;
